module.exports = __webpack_public_path__ + "static/media/5.b95dce99.png";